import { defineComponent } from 'vue';
import Image from '@hems/component/src/image/Image.vue';
import { BASIC_BUTTON_COLOR_TYPE, BASIC_BUTTON_SIZE } from '@hems/util/src/constant/button';
export default defineComponent({
    name: 'BasicButton',
    components: {
        Image,
    },
    inheritAttrs: false,
    props: {
        isSubmit: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: BASIC_BUTTON_SIZE.REGULAR,
        },
        colorType: {
            type: String,
            default: BASIC_BUTTON_COLOR_TYPE.PRIMARY,
        },
        beforeImage: {
            type: Object,
            default: null,
        },
        afterImage: {
            type: Object,
            default: null,
        },
        isCritical: {
            type: Boolean,
            default: false,
        },
    },
});
